








import WorkTypeManager from '@/components/settings/WorkTypeManager.vue'

export default {
    components: {
        WorkTypeManager
    },
    data() {
        return {}
    }
}
